import { OutOfBoundsStrategy } from "../drag-and-drop.interface";

export class NoopStrategy implements OutOfBoundsStrategy {
    /* Methods intentionally left empty as default strategy for out-of-bounds during drag-and-drop. */
    handleOutOfBounds(): void {
        return;
    }

    handleReturnInBounds(): void {
        return;
    }

    handleDragEnd(): void {
        return;
    }
}
